import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { endpoints } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = m[1];

    (async () => {
      try {
        const res = await endpoints.session(sessionId);
        setUser(res.data.user);
        // Clean URL
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true, state: { user: res.data.user } });
      } catch (e) {
        console.error("Auth failed", e);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 mx-auto border-2 border-[#C5A059] border-t-transparent rounded-full animate-spin" />
        <div className="mt-4 font-display text-lg">Establishing secure session…</div>
      </div>
    </div>
  );
}
